import Route from '@ember/routing/route';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';

export default class JournalsActiveRoute extends Route {
  @service declare fundsService: any;
  @service declare journalService: any;
  @service declare router: Router;

  async model() {
    await this.fundsService.confirmValidFundToken();
    await this.journalService.load();
    let activeSortedJournals = sortByProperties<any>(
      this.journalService.journals.filter((x: any) => x.active),
      ['startDate:desc'],
    );
    if (activeSortedJournals.length > 0) {
      this.router.transitionTo(
        'funds.fund.journals.journal',
        activeSortedJournals[0].id,
      );
    } else {
      this.router.transitionTo('funds.fund.journals.index');
    }
  }
}
